import { FunctionComponent } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  margin: 4px 0;
  border: 1px solid #e0d8d0;
  border-radius: 10px;
  background: #ffffff;
  overflow: hidden;

  > * + * {
    border-top: 1px solid #e8e0d8;
  }
`;

export const PlanLimitsCard: FunctionComponent<React.PropsWithChildren<unknown>> = ({
  children,
}) => <Card>{children}</Card>;
